/** Mirrors Sierra.Inventory.Models.Enums.PackagingType — keep the numeric values in sync. */
export enum PackagingType {
  Box = 0,
  Pallet = 1,
  Bag = 2,
  None = 3,
  Sack = 4,
  IbcTote = 5,
  Barrel = 6,
}

export interface PackagingTypeOption {
  value: PackagingType;
  labelKey: string;
  fallback: string;
}

/** Only the types the chemical Commercial Invoice counts (Totes, Boxes, Pallets, Barrels). */
export const CHEMICAL_LOT_PACKAGING_TYPES: PackagingTypeOption[] = [
  { value: PackagingType.IbcTote, labelKey: 'CreateLotItem.packaging_ibc_tote', fallback: 'IBC Tote' },
  { value: PackagingType.Box, labelKey: 'CreateLotItem.packaging_box', fallback: 'Box' },
  { value: PackagingType.Pallet, labelKey: 'CreateLotItem.packaging_pallet', fallback: 'Pallet' },
  { value: PackagingType.Barrel, labelKey: 'CreateLotItem.packaging_barrel', fallback: 'Barrel' },
];
